module.exports = __webpack_public_path__ + "img/T2A_rc_16.04a10cd0.png";